import React from "react";

export const TAB_DATE = 'p-datepicker-group--date';
export const TAB_HOUR = 'p-datepicker-group--hour';
export const DATE = 'date';
export const TIME = 'time';
